import transactionTypes from 'constants/transactionTypes';
import { Transaction } from 'types';

type GetTransactionAmountProps = {
  transaction: Transaction;
  sharesCount: number;
  nominalValue: number;
};

const calculateAmountForTransactionType = (
  transaction: Transaction,
  sharesCount: number
) => (transaction?.sharePrice || 0) * sharesCount;

const calculateAmountForNominalValue = (
  nominalValue: number,
  transaction: Transaction,
  sharesCount: number
) => (nominalValue + (transaction?.sharePremium || 0)) * sharesCount;

const isBuyOrSell = (transaction: Transaction) =>
  transaction?.transactionType === transactionTypes.BUY ||
  transaction?.transactionType === transactionTypes.SELL;

const isCapitalDecreaseWithSharePrice = (transaction: Transaction) =>
  transaction?.transactionType === transactionTypes.CAPITAL_DECREASE &&
  transaction?.sharePrice;

export const getTransactionAmount = ({
  transaction,
  sharesCount,
  nominalValue,
}: GetTransactionAmountProps) => {
  if (!transaction) {
    return 0;
  }

  if (transaction?.amount) {
    return transaction.amount;
  }

  const amount =
    isBuyOrSell(transaction) || isCapitalDecreaseWithSharePrice(transaction)
      ? calculateAmountForTransactionType(transaction, sharesCount)
      : calculateAmountForNominalValue(nominalValue, transaction, sharesCount);

  return amount;
};
